import { render, staticRenderFns } from "./BookingComplete.vue?vue&type=template&id=3dfb66bb&scoped=true&"
import script from "./BookingComplete.vue?vue&type=script&lang=js&"
export * from "./BookingComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dfb66bb",
  null
  
)

export default component.exports